module.exports = __webpack_public_path__ + "img/ico-line.562c88d3.svg";